import { render } from "./EditUnitDetails.vue?vue&type=template&id=43167d5d&scoped=true"
import script from "./EditUnitDetails.vue?vue&type=script&lang=js"
export * from "./EditUnitDetails.vue?vue&type=script&lang=js"

import "./EditUnitDetails.vue?vue&type=style&index=0&id=43167d5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43167d5d"]])

export default __exports__